// @ts-nocheck
import { makeStyles } from '@material-ui/core';

export const useNoteAndAttachmentFieldStyles = makeStyles({
  notesAndAttachmentLabel: {
    fontFamily: "'Roboto', sans serif",
    fontWeight: 500,
    fontSize: '14px',
    margin: '0 0 0 30px',
    color: '#5F6D83',
  },
  notesInput: {
    width: '648px',
    height: '80px',
    margin: '0 0 10px 30px',
  },
  attachmentContainer: {
    border: '1px dashed #98A5B9',
    borderRadius: '4px',
    width: '648px',
    backgroundColor: '#EAEDF1',
    height: '48px',
    maxWidth: 250,
    padding: '5px',
    marginTop: '10px',
  },
  attachmentContainerText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    height: '100%',
    cursor: 'pointer',
  },
  addIcon: {
    fontFamily: '"Roboto", sans serif',
    fontSize: '12px',
    color: '#5F6D83',
    border: '1px solid #5F6D83 ',
  },
  dropFileText: {
    fontFamily: '"Roboto", sans serif',
    fontWeight: 400,
    fontSize: '14px',
    color: '#6A737B',
  },
  multiAttachmentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  progress: {
    marginRight: '10px',
    alignSelf: 'center',
  },
  fileInput: {
    display: 'none',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  smallText: {
    fontSize: '10px',
    margin: 0,
  },
});
